/**
 * Customer-facing portal (task #29) — login-by-phone-OTP, then read-only
 * self-service views (own orders, own bills, own loyalty balance). Scoped
 * down from a full separate `apps/portal` SPA: same OTP mechanics as
 * `orders.ts`'s order-tracking OTP, but keyed to the customer (not one
 * order) so a returning customer sees everything, not just one tracking link.
 */
import { z } from 'zod';
export const requestPortalOtpSchema = z.object({
    businessCode: z.string().min(1).max(32),
    phone: z.string().min(7).max(20),
});
export const verifyPortalOtpSchema = z.object({
    businessCode: z.string().min(1).max(32),
    phone: z.string().min(7).max(20),
    code: z.string().regex(/^\d{6}$/, 'Enter the 6-digit code'),
});
//# sourceMappingURL=portal.js.map